import at from "@arcgis/core/geometry/Polygon";
import en from "@arcgis/core/layers/FeatureLayer";
import tn from "@arcgis/core/renderers/UniqueValueRenderer";
import Ze from "@arcgis/core/symbols/SimpleFillSymbol";
import { whenOnce as rn } from "@arcgis/core/core/reactiveUtils";
import et from "@arcgis/core/Graphic";
import * as nr from "@arcgis/core/geometry/operators/intersectsOperator";
import * as tt from "@arcgis/core/geometry/operators/projectOperator";
import * as nn from "@arcgis/core/geometry/operators/areaOperator";
import * as sn from "@arcgis/core/geometry/operators/intersectionOperator";
import on from "@arcgis/core/layers/Layer";
import an from "@arcgis/core/portal/PortalItem";
import sr, { createContext as cn, useContext as ln } from "react";
function ir(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: un } = Object.prototype, { getPrototypeOf: ht } = Object, { iterator: De, toStringTag: or } = Symbol, $e = ((t) => (e) => {
  const r = un.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), z = (t) => (t = t.toLowerCase(), (e) => $e(e) === t), Ue = (t) => (e) => typeof e === t, { isArray: ue } = Array, le = Ue("undefined");
function be(t) {
  return t !== null && !le(t) && t.constructor !== null && !le(t.constructor) && U(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const ar = z("ArrayBuffer");
function fn(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && ar(t.buffer), e;
}
const dn = Ue("string"), U = Ue("function"), cr = Ue("number"), ve = (t) => t !== null && typeof t == "object", hn = (t) => t === !0 || t === !1, _e = (t) => {
  if ($e(t) !== "object")
    return !1;
  const e = ht(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(or in t) && !(De in t);
}, pn = (t) => {
  if (!ve(t) || be(t))
    return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, mn = z("Date"), gn = z("File"), yn = z("Blob"), kn = z("FileList"), wn = (t) => ve(t) && U(t.pipe), bn = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || U(t.append) && ((e = $e(t)) === "formdata" || // detect form-data instance
  e === "object" && U(t.toString) && t.toString() === "[object FormData]"));
}, vn = z("URLSearchParams"), [En, Sn, Tn, Rn] = ["ReadableStream", "Request", "Response", "Headers"].map(z), On = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ee(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let n, s;
  if (typeof t != "object" && (t = [t]), ue(t))
    for (n = 0, s = t.length; n < s; n++)
      e.call(null, t[n], n, t);
  else {
    if (be(t))
      return;
    const i = r ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let c;
    for (n = 0; n < o; n++)
      c = i[n], e.call(null, t[c], c, t);
  }
}
function lr(t, e) {
  if (be(t))
    return null;
  e = e.toLowerCase();
  const r = Object.keys(t);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], e === s.toLowerCase())
      return s;
  return null;
}
const ne = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), ur = (t) => !le(t) && t !== ne;
function ct() {
  const { caseless: t, skipUndefined: e } = ur(this) && this || {}, r = {}, n = (s, i) => {
    const o = t && lr(r, i) || i;
    _e(r[o]) && _e(s) ? r[o] = ct(r[o], s) : _e(s) ? r[o] = ct({}, s) : ue(s) ? r[o] = s.slice() : (!e || !le(s)) && (r[o] = s);
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && Ee(arguments[s], n);
  return r;
}
const An = (t, e, r, { allOwnKeys: n } = {}) => (Ee(e, (s, i) => {
  r && U(s) ? t[i] = ir(s, r) : t[i] = s;
}, { allOwnKeys: n }), t), Cn = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Pn = (t, e, r, n) => {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, In = (t, e, r, n) => {
  let s, i, o;
  const c = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; )
      o = s[i], (!n || n(o, t, e)) && !c[o] && (e[o] = t[o], c[o] = !0);
    t = r !== !1 && ht(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, Fn = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const n = t.indexOf(e, r);
  return n !== -1 && n === r;
}, _n = (t) => {
  if (!t)
    return null;
  if (ue(t))
    return t;
  let e = t.length;
  if (!cr(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, xn = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && ht(Uint8Array)), jn = (t, e) => {
  const n = (t && t[De]).call(t);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    e.call(t, i[0], i[1]);
  }
}, Mn = (t, e) => {
  let r;
  const n = [];
  for (; (r = t.exec(e)) !== null; )
    n.push(r);
  return n;
}, Ln = z("HTMLFormElement"), Nn = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), Mt = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), Dn = z("RegExp"), fr = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), n = {};
  Ee(r, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (n[i] = o || s);
  }), Object.defineProperties(t, n);
}, $n = (t) => {
  fr(t, (e, r) => {
    if (U(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = t[r];
    if (U(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Un = (t, e) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return ue(t) ? n(t) : n(String(t).split(e)), r;
}, Bn = () => {
}, qn = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function Wn(t) {
  return !!(t && U(t.append) && t[or] === "FormData" && t[De]);
}
const Hn = (t) => {
  const e = new Array(10), r = (n, s) => {
    if (ve(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (be(n))
        return n;
      if (!("toJSON" in n)) {
        e[s] = n;
        const i = ue(n) ? [] : {};
        return Ee(n, (o, c) => {
          const l = r(o, s + 1);
          !le(l) && (i[c] = l);
        }), e[s] = void 0, i;
      }
    }
    return n;
  };
  return r(t, 0);
}, Vn = z("AsyncFunction"), Gn = (t) => t && (ve(t) || U(t)) && U(t.then) && U(t.catch), dr = ((t, e) => t ? setImmediate : e ? ((r, n) => (ne.addEventListener("message", ({ source: s, data: i }) => {
  s === ne && i === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), ne.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  U(ne.postMessage)
), zn = typeof queueMicrotask < "u" ? queueMicrotask.bind(ne) : typeof process < "u" && process.nextTick || dr, Jn = (t) => t != null && U(t[De]), f = {
  isArray: ue,
  isArrayBuffer: ar,
  isBuffer: be,
  isFormData: bn,
  isArrayBufferView: fn,
  isString: dn,
  isNumber: cr,
  isBoolean: hn,
  isObject: ve,
  isPlainObject: _e,
  isEmptyObject: pn,
  isReadableStream: En,
  isRequest: Sn,
  isResponse: Tn,
  isHeaders: Rn,
  isUndefined: le,
  isDate: mn,
  isFile: gn,
  isBlob: yn,
  isRegExp: Dn,
  isFunction: U,
  isStream: wn,
  isURLSearchParams: vn,
  isTypedArray: xn,
  isFileList: kn,
  forEach: Ee,
  merge: ct,
  extend: An,
  trim: On,
  stripBOM: Cn,
  inherits: Pn,
  toFlatObject: In,
  kindOf: $e,
  kindOfTest: z,
  endsWith: Fn,
  toArray: _n,
  forEachEntry: jn,
  matchAll: Mn,
  isHTMLForm: Ln,
  hasOwnProperty: Mt,
  hasOwnProp: Mt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: fr,
  freezeMethods: $n,
  toObjectSet: Un,
  toCamelCase: Nn,
  noop: Bn,
  toFiniteNumber: qn,
  findKey: lr,
  global: ne,
  isContextDefined: ur,
  isSpecCompliantForm: Wn,
  toJSONObject: Hn,
  isAsyncFn: Vn,
  isThenable: Gn,
  setImmediate: dr,
  asap: zn,
  isIterable: Jn
};
function S(t, e, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
f.inherits(S, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: f.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const hr = S.prototype, pr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  pr[t] = { value: t };
});
Object.defineProperties(S, pr);
Object.defineProperty(hr, "isAxiosError", { value: !0 });
S.from = (t, e, r, n, s, i) => {
  const o = Object.create(hr);
  f.toFlatObject(t, o, function(u) {
    return u !== Error.prototype;
  }, (d) => d !== "isAxiosError");
  const c = t && t.message ? t.message : "Error", l = e == null && t ? t.code : e;
  return S.call(o, c, l, r, n, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const Kn = null;
function lt(t) {
  return f.isPlainObject(t) || f.isArray(t);
}
function mr(t) {
  return f.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Lt(t, e, r) {
  return t ? t.concat(e).map(function(s, i) {
    return s = mr(s), !r && i ? "[" + s + "]" : s;
  }).join(r ? "." : "") : e;
}
function Yn(t) {
  return f.isArray(t) && !t.some(lt);
}
const Xn = f.toFlatObject(f, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Be(t, e, r) {
  if (!f.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = f.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, y) {
    return !f.isUndefined(y[g]);
  });
  const n = r.metaTokens, s = r.visitor || u, i = r.dots, o = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && f.isSpecCompliantForm(e);
  if (!f.isFunction(s))
    throw new TypeError("visitor must be a function");
  function d(h) {
    if (h === null)
      return "";
    if (f.isDate(h))
      return h.toISOString();
    if (f.isBoolean(h))
      return h.toString();
    if (!l && f.isBlob(h))
      throw new S("Blob is not supported. Use a Buffer instead.");
    return f.isArrayBuffer(h) || f.isTypedArray(h) ? l && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function u(h, g, y) {
    let O = h;
    if (h && !y && typeof h == "object") {
      if (f.endsWith(g, "{}"))
        g = n ? g : g.slice(0, -2), h = JSON.stringify(h);
      else if (f.isArray(h) && Yn(h) || (f.isFileList(h) || f.endsWith(g, "[]")) && (O = f.toArray(h)))
        return g = mr(g), O.forEach(function(P, x) {
          !(f.isUndefined(P) || P === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Lt([g], x, i) : o === null ? g : g + "[]",
            d(P)
          );
        }), !1;
    }
    return lt(h) ? !0 : (e.append(Lt(y, g, i), d(h)), !1);
  }
  const p = [], w = Object.assign(Xn, {
    defaultVisitor: u,
    convertValue: d,
    isVisitable: lt
  });
  function b(h, g) {
    if (!f.isUndefined(h)) {
      if (p.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      p.push(h), f.forEach(h, function(O, E) {
        (!(f.isUndefined(O) || O === null) && s.call(
          e,
          O,
          f.isString(E) ? E.trim() : E,
          g,
          w
        )) === !0 && b(O, g ? g.concat(E) : [E]);
      }), p.pop();
    }
  }
  if (!f.isObject(t))
    throw new TypeError("data must be an object");
  return b(t), e;
}
function Nt(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function pt(t, e) {
  this._pairs = [], t && Be(t, this, e);
}
const gr = pt.prototype;
gr.append = function(e, r) {
  this._pairs.push([e, r]);
};
gr.toString = function(e) {
  const r = e ? function(n) {
    return e.call(this, n, Nt);
  } : Nt;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function Qn(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function yr(t, e, r) {
  if (!e)
    return t;
  const n = r && r.encode || Qn;
  f.isFunction(r) && (r = {
    serialize: r
  });
  const s = r && r.serialize;
  let i;
  if (s ? i = s(e, r) : i = f.isURLSearchParams(e) ? e.toString() : new pt(e, r).toString(n), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class Zn {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    f.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Dt = Zn, kr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, es = typeof URLSearchParams < "u" ? URLSearchParams : pt, ts = typeof FormData < "u" ? FormData : null, rs = typeof Blob < "u" ? Blob : null, ns = {
  isBrowser: !0,
  classes: {
    URLSearchParams: es,
    FormData: ts,
    Blob: rs
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, mt = typeof window < "u" && typeof document < "u", ut = typeof navigator == "object" && navigator || void 0, ss = mt && (!ut || ["ReactNative", "NativeScript", "NS"].indexOf(ut.product) < 0), is = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), os = mt && window.location.href || "http://localhost", as = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: mt,
  hasStandardBrowserEnv: ss,
  hasStandardBrowserWebWorkerEnv: is,
  navigator: ut,
  origin: os
}, Symbol.toStringTag, { value: "Module" })), M = {
  ...as,
  ...ns
};
function cs(t, e) {
  return Be(t, new M.classes.URLSearchParams(), {
    visitor: function(r, n, s, i) {
      return M.isNode && f.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function ls(t) {
  return f.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function us(t) {
  const e = {}, r = Object.keys(t);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], e[i] = t[i];
  return e;
}
function wr(t) {
  function e(r, n, s, i) {
    let o = r[i++];
    if (o === "__proto__")
      return !0;
    const c = Number.isFinite(+o), l = i >= r.length;
    return o = !o && f.isArray(s) ? s.length : o, l ? (f.hasOwnProp(s, o) ? s[o] = [s[o], n] : s[o] = n, !c) : ((!s[o] || !f.isObject(s[o])) && (s[o] = []), e(r, n, s[o], i) && f.isArray(s[o]) && (s[o] = us(s[o])), !c);
  }
  if (f.isFormData(t) && f.isFunction(t.entries)) {
    const r = {};
    return f.forEachEntry(t, (n, s) => {
      e(ls(n), s, r, 0);
    }), r;
  }
  return null;
}
function fs(t, e, r) {
  if (f.isString(t))
    try {
      return (e || JSON.parse)(t), f.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(t);
}
const gt = {
  transitional: kr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, i = f.isObject(e);
    if (i && f.isHTMLForm(e) && (e = new FormData(e)), f.isFormData(e))
      return s ? JSON.stringify(wr(e)) : e;
    if (f.isArrayBuffer(e) || f.isBuffer(e) || f.isStream(e) || f.isFile(e) || f.isBlob(e) || f.isReadableStream(e))
      return e;
    if (f.isArrayBufferView(e))
      return e.buffer;
    if (f.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let c;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return cs(e, this.formSerializer).toString();
      if ((c = f.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Be(
          c ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || s ? (r.setContentType("application/json", !1), fs(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || gt.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (f.isResponse(e) || f.isReadableStream(e))
      return e;
    if (e && f.isString(e) && (n && !this.responseType || s)) {
      const o = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (c) {
        if (o)
          throw c.name === "SyntaxError" ? S.from(c, S.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: M.classes.FormData,
    Blob: M.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
f.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  gt.headers[t] = {};
});
const yt = gt, ds = f.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), hs = (t) => {
  const e = {};
  let r, n, s;
  return t && t.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), r = o.substring(0, s).trim().toLowerCase(), n = o.substring(s + 1).trim(), !(!r || e[r] && ds[r]) && (r === "set-cookie" ? e[r] ? e[r].push(n) : e[r] = [n] : e[r] = e[r] ? e[r] + ", " + n : n);
  }), e;
}, $t = Symbol("internals");
function ye(t) {
  return t && String(t).trim().toLowerCase();
}
function xe(t) {
  return t === !1 || t == null ? t : f.isArray(t) ? t.map(xe) : String(t);
}
function ps(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(t); )
    e[n[1]] = n[2];
  return e;
}
const ms = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function rt(t, e, r, n, s) {
  if (f.isFunction(n))
    return n.call(this, e, r);
  if (s && (e = r), !!f.isString(e)) {
    if (f.isString(n))
      return e.indexOf(n) !== -1;
    if (f.isRegExp(n))
      return n.test(e);
  }
}
function gs(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, n) => r.toUpperCase() + n);
}
function ys(t, e) {
  const r = f.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(t, n + r, {
      value: function(s, i, o) {
        return this[n].call(this, e, s, i, o);
      },
      configurable: !0
    });
  });
}
class qe {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, n) {
    const s = this;
    function i(c, l, d) {
      const u = ye(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const p = f.findKey(s, u);
      (!p || s[p] === void 0 || d === !0 || d === void 0 && s[p] !== !1) && (s[p || l] = xe(c));
    }
    const o = (c, l) => f.forEach(c, (d, u) => i(d, u, l));
    if (f.isPlainObject(e) || e instanceof this.constructor)
      o(e, r);
    else if (f.isString(e) && (e = e.trim()) && !ms(e))
      o(hs(e), r);
    else if (f.isObject(e) && f.isIterable(e)) {
      let c = {}, l, d;
      for (const u of e) {
        if (!f.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        c[d = u[0]] = (l = c[d]) ? f.isArray(l) ? [...l, u[1]] : [l, u[1]] : u[1];
      }
      o(c, r);
    } else
      e != null && i(r, e, n);
    return this;
  }
  get(e, r) {
    if (e = ye(e), e) {
      const n = f.findKey(this, e);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return ps(s);
        if (f.isFunction(r))
          return r.call(this, s, n);
        if (f.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = ye(e), e) {
      const n = f.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!r || rt(this, this[n], n, r)));
    }
    return !1;
  }
  delete(e, r) {
    const n = this;
    let s = !1;
    function i(o) {
      if (o = ye(o), o) {
        const c = f.findKey(n, o);
        c && (!r || rt(n, n[c], c, r)) && (delete n[c], s = !0);
      }
    }
    return f.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const i = r[n];
      (!e || rt(this, this[i], i, e, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const r = this, n = {};
    return f.forEach(this, (s, i) => {
      const o = f.findKey(n, i);
      if (o) {
        r[o] = xe(s), delete r[i];
        return;
      }
      const c = e ? gs(i) : String(i).trim();
      c !== i && delete r[i], r[c] = xe(s), n[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return f.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = e && f.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const n = new this(e);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(e) {
    const n = (this[$t] = this[$t] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const c = ye(o);
      n[c] || (ys(s, o), n[c] = !0);
    }
    return f.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
qe.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
f.reduceDescriptors(qe.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(n) {
      this[r] = n;
    }
  };
});
f.freezeMethods(qe);
const G = qe;
function nt(t, e) {
  const r = this || yt, n = e || r, s = G.from(n.headers);
  let i = n.data;
  return f.forEach(t, function(c) {
    i = c.call(r, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function br(t) {
  return !!(t && t.__CANCEL__);
}
function fe(t, e, r) {
  S.call(this, t ?? "canceled", S.ERR_CANCELED, e, r), this.name = "CanceledError";
}
f.inherits(fe, S, {
  __CANCEL__: !0
});
function vr(t, e, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? t(r) : e(new S(
    "Request failed with status code " + r.status,
    [S.ERR_BAD_REQUEST, S.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function ks(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function ws(t, e) {
  t = t || 10;
  const r = new Array(t), n = new Array(t);
  let s = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const d = Date.now(), u = n[i];
    o || (o = d), r[s] = l, n[s] = d;
    let p = i, w = 0;
    for (; p !== s; )
      w += r[p++], p = p % t;
    if (s = (s + 1) % t, s === i && (i = (i + 1) % t), d - o < e)
      return;
    const b = u && d - u;
    return b ? Math.round(w * 1e3 / b) : void 0;
  };
}
function bs(t, e) {
  let r = 0, n = 1e3 / e, s, i;
  const o = (d, u = Date.now()) => {
    r = u, s = null, i && (clearTimeout(i), i = null), t(...d);
  };
  return [(...d) => {
    const u = Date.now(), p = u - r;
    p >= n ? o(d, u) : (s = d, i || (i = setTimeout(() => {
      i = null, o(s);
    }, n - p)));
  }, () => s && o(s)];
}
const Le = (t, e, r = 3) => {
  let n = 0;
  const s = ws(50, 250);
  return bs((i) => {
    const o = i.loaded, c = i.lengthComputable ? i.total : void 0, l = o - n, d = s(l), u = o <= c;
    n = o;
    const p = {
      loaded: o,
      total: c,
      progress: c ? o / c : void 0,
      bytes: l,
      rate: d || void 0,
      estimated: d && c && u ? (c - o) / d : void 0,
      event: i,
      lengthComputable: c != null,
      [e ? "download" : "upload"]: !0
    };
    t(p);
  }, r);
}, Ut = (t, e) => {
  const r = t != null;
  return [(n) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: n
  }), e[1]];
}, Bt = (t) => (...e) => f.asap(() => t(...e)), vs = M.hasStandardBrowserEnv ? ((t, e) => (r) => (r = new URL(r, M.origin), t.protocol === r.protocol && t.host === r.host && (e || t.port === r.port)))(
  new URL(M.origin),
  M.navigator && /(msie|trident)/i.test(M.navigator.userAgent)
) : () => !0, Es = M.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, n, s, i, o) {
      if (typeof document > "u")
        return;
      const c = [`${t}=${encodeURIComponent(e)}`];
      f.isNumber(r) && c.push(`expires=${new Date(r).toUTCString()}`), f.isString(n) && c.push(`path=${n}`), f.isString(s) && c.push(`domain=${s}`), i === !0 && c.push("secure"), f.isString(o) && c.push(`SameSite=${o}`), document.cookie = c.join("; ");
    },
    read(t) {
      if (typeof document > "u")
        return null;
      const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
      return e ? decodeURIComponent(e[1]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ss(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function Ts(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Er(t, e, r) {
  let n = !Ss(e);
  return t && (n || r == !1) ? Ts(t, e) : e;
}
const qt = (t) => t instanceof G ? { ...t } : t;
function se(t, e) {
  e = e || {};
  const r = {};
  function n(d, u, p, w) {
    return f.isPlainObject(d) && f.isPlainObject(u) ? f.merge.call({ caseless: w }, d, u) : f.isPlainObject(u) ? f.merge({}, u) : f.isArray(u) ? u.slice() : u;
  }
  function s(d, u, p, w) {
    if (f.isUndefined(u)) {
      if (!f.isUndefined(d))
        return n(void 0, d, p, w);
    } else
      return n(d, u, p, w);
  }
  function i(d, u) {
    if (!f.isUndefined(u))
      return n(void 0, u);
  }
  function o(d, u) {
    if (f.isUndefined(u)) {
      if (!f.isUndefined(d))
        return n(void 0, d);
    } else
      return n(void 0, u);
  }
  function c(d, u, p) {
    if (p in e)
      return n(d, u);
    if (p in t)
      return n(void 0, d);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: c,
    headers: (d, u, p) => s(qt(d), qt(u), p, !0)
  };
  return f.forEach(Object.keys({ ...t, ...e }), function(u) {
    const p = l[u] || s, w = p(t[u], e[u], u);
    f.isUndefined(w) && p !== c || (r[u] = w);
  }), r;
}
const Sr = (t) => {
  const e = se({}, t);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: c } = e;
  if (e.headers = o = G.from(o), e.url = yr(Er(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), c && o.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  ), f.isFormData(r)) {
    if (M.hasStandardBrowserEnv || M.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (f.isFunction(r.getHeaders)) {
      const l = r.getHeaders(), d = ["content-type", "content-length"];
      Object.entries(l).forEach(([u, p]) => {
        d.includes(u.toLowerCase()) && o.set(u, p);
      });
    }
  }
  if (M.hasStandardBrowserEnv && (n && f.isFunction(n) && (n = n(e)), n || n !== !1 && vs(e.url))) {
    const l = s && i && Es.read(i);
    l && o.set(s, l);
  }
  return e;
}, Rs = typeof XMLHttpRequest < "u", Os = Rs && function(t) {
  return new Promise(function(r, n) {
    const s = Sr(t);
    let i = s.data;
    const o = G.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: l, onDownloadProgress: d } = s, u, p, w, b, h;
    function g() {
      b && b(), h && h(), s.cancelToken && s.cancelToken.unsubscribe(u), s.signal && s.signal.removeEventListener("abort", u);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function O() {
      if (!y)
        return;
      const P = G.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), B = {
        data: !c || c === "text" || c === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: P,
        config: t,
        request: y
      };
      vr(function(D) {
        r(D), g();
      }, function(D) {
        n(D), g();
      }, B), y = null;
    }
    "onloadend" in y ? y.onloadend = O : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(O);
    }, y.onabort = function() {
      y && (n(new S("Request aborted", S.ECONNABORTED, t, y)), y = null);
    }, y.onerror = function(x) {
      const B = x && x.message ? x.message : "Network Error", X = new S(B, S.ERR_NETWORK, t, y);
      X.event = x || null, n(X), y = null;
    }, y.ontimeout = function() {
      let x = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const B = s.transitional || kr;
      s.timeoutErrorMessage && (x = s.timeoutErrorMessage), n(new S(
        x,
        B.clarifyTimeoutError ? S.ETIMEDOUT : S.ECONNABORTED,
        t,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && f.forEach(o.toJSON(), function(x, B) {
      y.setRequestHeader(B, x);
    }), f.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), c && c !== "json" && (y.responseType = s.responseType), d && ([w, h] = Le(d, !0), y.addEventListener("progress", w)), l && y.upload && ([p, b] = Le(l), y.upload.addEventListener("progress", p), y.upload.addEventListener("loadend", b)), (s.cancelToken || s.signal) && (u = (P) => {
      y && (n(!P || P.type ? new fe(null, t, y) : P), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(u), s.signal && (s.signal.aborted ? u() : s.signal.addEventListener("abort", u)));
    const E = ks(s.url);
    if (E && M.protocols.indexOf(E) === -1) {
      n(new S("Unsupported protocol " + E + ":", S.ERR_BAD_REQUEST, t));
      return;
    }
    y.send(i || null);
  });
}, As = (t, e) => {
  const { length: r } = t = t ? t.filter(Boolean) : [];
  if (e || r) {
    let n = new AbortController(), s;
    const i = function(d) {
      if (!s) {
        s = !0, c();
        const u = d instanceof Error ? d : this.reason;
        n.abort(u instanceof S ? u : new fe(u instanceof Error ? u.message : u));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new S(`timeout ${e} of ms exceeded`, S.ETIMEDOUT));
    }, e);
    const c = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(i) : d.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((d) => d.addEventListener("abort", i));
    const { signal: l } = n;
    return l.unsubscribe = () => f.asap(c), l;
  }
}, Cs = As, Ps = function* (t, e) {
  let r = t.byteLength;
  if (!e || r < e) {
    yield t;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + e, yield t.slice(n, s), n = s;
}, Is = async function* (t, e) {
  for await (const r of Fs(t))
    yield* Ps(r, e);
}, Fs = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await e.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await e.cancel();
  }
}, Wt = (t, e, r, n) => {
  const s = Is(t, e);
  let i = 0, o, c = (l) => {
    o || (o = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: d, value: u } = await s.next();
        if (d) {
          c(), l.close();
          return;
        }
        let p = u.byteLength;
        if (r) {
          let w = i += p;
          r(w);
        }
        l.enqueue(new Uint8Array(u));
      } catch (d) {
        throw c(d), d;
      }
    },
    cancel(l) {
      return c(l), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ht = 64 * 1024, { isFunction: Fe } = f, _s = (({ Request: t, Response: e }) => ({
  Request: t,
  Response: e
}))(f.global), {
  ReadableStream: Vt,
  TextEncoder: Gt
} = f.global, zt = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, xs = (t) => {
  t = f.merge.call({
    skipUndefined: !0
  }, _s, t);
  const { fetch: e, Request: r, Response: n } = t, s = e ? Fe(e) : typeof fetch == "function", i = Fe(r), o = Fe(n);
  if (!s)
    return !1;
  const c = s && Fe(Vt), l = s && (typeof Gt == "function" ? ((h) => (g) => h.encode(g))(new Gt()) : async (h) => new Uint8Array(await new r(h).arrayBuffer())), d = i && c && zt(() => {
    let h = !1;
    const g = new r(M.origin, {
      body: new Vt(),
      method: "POST",
      get duplex() {
        return h = !0, "half";
      }
    }).headers.has("Content-Type");
    return h && !g;
  }), u = o && c && zt(() => f.isReadableStream(new n("").body)), p = {
    stream: u && ((h) => h.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !p[h] && (p[h] = (g, y) => {
      let O = g && g[h];
      if (O)
        return O.call(g);
      throw new S(`Response type '${h}' is not supported`, S.ERR_NOT_SUPPORT, y);
    });
  });
  const w = async (h) => {
    if (h == null)
      return 0;
    if (f.isBlob(h))
      return h.size;
    if (f.isSpecCompliantForm(h))
      return (await new r(M.origin, {
        method: "POST",
        body: h
      }).arrayBuffer()).byteLength;
    if (f.isArrayBufferView(h) || f.isArrayBuffer(h))
      return h.byteLength;
    if (f.isURLSearchParams(h) && (h = h + ""), f.isString(h))
      return (await l(h)).byteLength;
  }, b = async (h, g) => {
    const y = f.toFiniteNumber(h.getContentLength());
    return y ?? w(g);
  };
  return async (h) => {
    let {
      url: g,
      method: y,
      data: O,
      signal: E,
      cancelToken: P,
      timeout: x,
      onDownloadProgress: B,
      onUploadProgress: X,
      responseType: D,
      headers: de,
      withCredentials: ee = "same-origin",
      fetchOptions: Se
    } = Sr(h), Te = e || fetch;
    D = D ? (D + "").toLowerCase() : "text";
    let te = Cs([E, P && P.toAbortSignal()], x), j = null;
    const L = te && te.unsubscribe && (() => {
      te.unsubscribe();
    });
    let Z;
    try {
      if (X && d && y !== "get" && y !== "head" && (Z = await b(de, O)) !== 0) {
        let V = new r(g, {
          method: "POST",
          body: O,
          duplex: "half"
        }), Q;
        if (f.isFormData(O) && (Q = V.headers.get("content-type")) && de.setContentType(Q), V.body) {
          const [ie, oe] = Ut(
            Z,
            Le(Bt(X))
          );
          O = Wt(V.body, Ht, ie, oe);
        }
      }
      f.isString(ee) || (ee = ee ? "include" : "omit");
      const q = i && "credentials" in r.prototype, he = {
        ...Se,
        signal: te,
        method: y.toUpperCase(),
        headers: de.normalize().toJSON(),
        body: O,
        duplex: "half",
        credentials: q ? ee : void 0
      };
      j = i && new r(g, he);
      let H = await (i ? Te(j, Se) : Te(g, he));
      const pe = u && (D === "stream" || D === "response");
      if (u && (B || pe && L)) {
        const V = {};
        ["status", "statusText", "headers"].forEach((Oe) => {
          V[Oe] = H[Oe];
        });
        const Q = f.toFiniteNumber(H.headers.get("content-length")), [ie, oe] = B && Ut(
          Q,
          Le(Bt(B), !0)
        ) || [];
        H = new n(
          Wt(H.body, Ht, ie, () => {
            oe && oe(), L && L();
          }),
          V
        );
      }
      D = D || "text";
      let Re = await p[f.findKey(p, D) || "text"](H, h);
      return !pe && L && L(), await new Promise((V, Q) => {
        vr(V, Q, {
          data: Re,
          headers: G.from(H.headers),
          status: H.status,
          statusText: H.statusText,
          config: h,
          request: j
        });
      });
    } catch (q) {
      throw L && L(), q && q.name === "TypeError" && /Load failed|fetch/i.test(q.message) ? Object.assign(
        new S("Network Error", S.ERR_NETWORK, h, j),
        {
          cause: q.cause || q
        }
      ) : S.from(q, q && q.code, h, j);
    }
  };
}, js = /* @__PURE__ */ new Map(), Tr = (t) => {
  let e = t && t.env || {};
  const { fetch: r, Request: n, Response: s } = e, i = [
    n,
    s,
    r
  ];
  let o = i.length, c = o, l, d, u = js;
  for (; c--; )
    l = i[c], d = u.get(l), d === void 0 && u.set(l, d = c ? /* @__PURE__ */ new Map() : xs(e)), u = d;
  return d;
};
Tr();
const kt = {
  http: Kn,
  xhr: Os,
  fetch: {
    get: Tr
  }
};
f.forEach(kt, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Jt = (t) => `- ${t}`, Ms = (t) => f.isFunction(t) || t === null || t === !1;
function Ls(t, e) {
  t = f.isArray(t) ? t : [t];
  const { length: r } = t;
  let n, s;
  const i = {};
  for (let o = 0; o < r; o++) {
    n = t[o];
    let c;
    if (s = n, !Ms(n) && (s = kt[(c = String(n)).toLowerCase()], s === void 0))
      throw new S(`Unknown adapter '${c}'`);
    if (s && (f.isFunction(s) || (s = s.get(e))))
      break;
    i[c || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(
      ([l, d]) => `adapter ${l} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let c = r ? o.length > 1 ? `since :
` + o.map(Jt).join(`
`) : " " + Jt(o[0]) : "as no adapter specified";
    throw new S(
      "There is no suitable adapter to dispatch the request " + c,
      "ERR_NOT_SUPPORT"
    );
  }
  return s;
}
const Rr = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Ls,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: kt
};
function st(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new fe(null, t);
}
function Kt(t) {
  return st(t), t.headers = G.from(t.headers), t.data = nt.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Rr.getAdapter(t.adapter || yt.adapter, t)(t).then(function(n) {
    return st(t), n.data = nt.call(
      t,
      t.transformResponse,
      n
    ), n.headers = G.from(n.headers), n;
  }, function(n) {
    return br(n) || (st(t), n && n.response && (n.response.data = nt.call(
      t,
      t.transformResponse,
      n.response
    ), n.response.headers = G.from(n.response.headers))), Promise.reject(n);
  });
}
const Or = "1.13.2", We = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  We[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Yt = {};
We.transitional = function(e, r, n) {
  function s(i, o) {
    return "[Axios v" + Or + "] Transitional option '" + i + "'" + o + (n ? ". " + n : "");
  }
  return (i, o, c) => {
    if (e === !1)
      throw new S(
        s(o, " has been removed" + (r ? " in " + r : "")),
        S.ERR_DEPRECATED
      );
    return r && !Yt[o] && (Yt[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, o, c) : !0;
  };
};
We.spelling = function(e) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function Ns(t, e, r) {
  if (typeof t != "object")
    throw new S("options must be an object", S.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(t);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], o = e[i];
    if (o) {
      const c = t[i], l = c === void 0 || o(c, i, t);
      if (l !== !0)
        throw new S("option " + i + " must be " + l, S.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new S("Unknown option " + i, S.ERR_BAD_OPTION);
  }
}
const je = {
  assertOptions: Ns,
  validators: We
}, J = je.validators;
class Ne {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Dt(),
      response: new Dt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = se(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: i } = r;
    n !== void 0 && je.assertOptions(n, {
      silentJSONParsing: J.transitional(J.boolean),
      forcedJSONParsing: J.transitional(J.boolean),
      clarifyTimeoutError: J.transitional(J.boolean)
    }, !1), s != null && (f.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : je.assertOptions(s, {
      encode: J.function,
      serialize: J.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), je.assertOptions(r, {
      baseUrl: J.spelling("baseURL"),
      withXsrfToken: J.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = i && f.merge(
      i.common,
      i[r.method]
    );
    i && f.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), r.headers = G.concat(o, i);
    const c = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(r) === !1 || (l = l && g.synchronous, c.unshift(g.fulfilled, g.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(g) {
      d.push(g.fulfilled, g.rejected);
    });
    let u, p = 0, w;
    if (!l) {
      const h = [Kt.bind(this), void 0];
      for (h.unshift(...c), h.push(...d), w = h.length, u = Promise.resolve(r); p < w; )
        u = u.then(h[p++], h[p++]);
      return u;
    }
    w = c.length;
    let b = r;
    for (; p < w; ) {
      const h = c[p++], g = c[p++];
      try {
        b = h(b);
      } catch (y) {
        g.call(this, y);
        break;
      }
    }
    try {
      u = Kt.call(this, b);
    } catch (h) {
      return Promise.reject(h);
    }
    for (p = 0, w = d.length; p < w; )
      u = u.then(d[p++], d[p++]);
    return u;
  }
  getUri(e) {
    e = se(this.defaults, e);
    const r = Er(e.baseURL, e.url, e.allowAbsoluteUrls);
    return yr(r, e.params, e.paramsSerializer);
  }
}
f.forEach(["delete", "get", "head", "options"], function(e) {
  Ne.prototype[e] = function(r, n) {
    return this.request(se(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
f.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(i, o, c) {
      return this.request(se(c || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  Ne.prototype[e] = r(), Ne.prototype[e + "Form"] = r(!0);
});
const Me = Ne;
class wt {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((c) => {
        n.subscribe(c), i = c;
      }).then(s);
      return o.cancel = function() {
        n.unsubscribe(i);
      }, o;
    }, e(function(i, o, c) {
      n.reason || (n.reason = new fe(i, o, c), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), r = (n) => {
      e.abort(n);
    };
    return this.subscribe(r), e.signal.unsubscribe = () => this.unsubscribe(r), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new wt(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
const Ds = wt;
function $s(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Us(t) {
  return f.isObject(t) && t.isAxiosError === !0;
}
const ft = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(ft).forEach(([t, e]) => {
  ft[e] = t;
});
const Bs = ft;
function Ar(t) {
  const e = new Me(t), r = ir(Me.prototype.request, e);
  return f.extend(r, Me.prototype, e, { allOwnKeys: !0 }), f.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(s) {
    return Ar(se(t, s));
  }, r;
}
const _ = Ar(yt);
_.Axios = Me;
_.CanceledError = fe;
_.CancelToken = Ds;
_.isCancel = br;
_.VERSION = Or;
_.toFormData = Be;
_.AxiosError = S;
_.Cancel = _.CanceledError;
_.all = function(e) {
  return Promise.all(e);
};
_.spread = $s;
_.isAxiosError = Us;
_.mergeConfig = se;
_.AxiosHeaders = G;
_.formToJSON = (t) => wr(f.isHTMLForm(t) ? new FormData(t) : t);
_.getAdapter = Rr.getAdapter;
_.HttpStatusCode = Bs;
_.default = _;
const Y = _, Xt = async (t, e, r, n) => {
  if (!r)
    return Promise.resolve(null);
  const s = `${t}/matrikkelenhet/${e}${n ? "/" + n : ""}`;
  try {
    return (await Y.get(s, {
      params: { token: r }
    })).data;
  } catch {
    return Promise.reject("Feil med henting av matrikkelinformasjon. Prøv igjen.");
  }
}, qs = (t) => {
  const e = t?.adresser;
  return Array.isArray(e) ? e.map((r) => `${r.adressenavn ?? ""} ${r.nummer ?? ""}${r.bokstav ?? ""}`.trim()).filter(Boolean) : [];
}, ii = async (t, e, r) => {
  const n = `${t}/Matrikkelenhet/finn`, s = await bt(n, { geometry: e }, !1, r);
  if (!s?.matrikkelenheter)
    return [];
  const i = s.matrikkelenheter.map((l) => ({
    matrikkelenhetId: l.matrikkelenhetId,
    gardsnr: l.gardsnummer,
    bruksnr: l.bruksnummer,
    festenr: l.festenummer,
    seksjonsnr: l.seksjonsnummer,
    kommunenavn: l.kommunenavn,
    teigIds: l.teigIdsForGeometri ?? [],
    teigIdsForGeometri: l.teigIdsForGeometri ?? null,
    anleggsprojeksjonsflateIds: l.anleggsprosjeksjonsflateIdsForGeometri ?? [],
    seksjoner: []
  })), o = i.filter((l) => l.seksjonsnr === 0), c = i.filter((l) => l.seksjonsnr > 0);
  for (const l of c) {
    const d = o.find(
      (u) => u.gardsnr === l.gardsnr && u.bruksnr === l.bruksnr && u.festenr === l.festenr
    );
    d ? d.seksjoner.push(l) : o.push(l);
  }
  return o;
}, Qt = async (t, e, r, n) => {
  if (e.length === 0)
    return [];
  const s = `${t}/Teig/geometri`, i = await bt(s, { teigIds: e, spatialReferenceWkid: r }, !1, n);
  return i?.teiger ? i.teiger.filter((o) => o.geometry).map((o) => ({ teigId: o.teigId, polygon: at.fromJSON(o.geometry) })) : [];
}, oi = (t, e, r) => {
  const n = `${t}/matrikkelenhet/${e}/rapport?token=${r}`;
  window.open(n);
}, ai = (t, e, r) => {
  const n = `${t}/grunnbok/kartverket/rapport?kommunenummer=${e.knr}&gardsnummer=${e.gnr}&bruksnummer=${e.bnr}&festenummer=${e.fnr}&seksjonsnummer=${e.snr}&token=${r}`;
  window.open(n);
}, it = async (t, e, r) => {
  const n = `${t}/Matrikkelenhet/finnvedgeometri`, i = await bt(n, { geometry: e }, !1, r);
  return i?.eiendommer ? (i.eiendommer.forEach((o) => o.teigIds = o.teigIdsForGeometri), i.eiendommer) : (console.warn(`[geoeiendom] finnvedgeometri ga ingen eiendommer (geometri-wkid=${e.spatialReference?.wkid})`), []);
}, ci = async (t, e, r, n, s, i = 0, o = 0) => {
  if (!s)
    return Promise.reject("No token available");
  const c = `${t}/Matrikkelenhet/matrikkelenhetid`;
  try {
    return (await Y.get(c, {
      params: {
        Kommunenummer: e,
        Gardsnummer: r,
        Bruksnummer: n,
        Festenummer: i,
        Seksjonsnummer: o,
        token: s
      }
    })).data.matrikkelenhetId;
  } catch {
    return Promise.reject("Failed to get matrikkelEnhetId");
  }
}, bt = async (t, e, r, n) => {
  if (!n)
    return Promise.resolve(null);
  const s = `${t}?Token=${n}`, i = r ? "blob" : "json", o = {
    "Content-Type": "application/json"
  };
  try {
    return (await Y.post(s, e, { headers: o, responseType: i })).data;
  } catch (c) {
    const l = c?.response?.status;
    return console.warn(`[geoeiendom] POST feilet${l ? ` (HTTP ${l})` : ""}: '${t}'. ${c?.message ?? c}`), null;
  }
}, Zt = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function ot(t) {
  try {
    return Math.abs(nn.execute(t, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function Ws(t, e, r = {}) {
  if (!t || !e)
    return { keep: !0, reason: "missing-geometry" };
  const n = r.minAreaM2 ?? Zt.minAreaM2, s = r.minRatio ?? Zt.minRatio, i = t.spatialReference?.wkid, o = e.spatialReference?.wkid;
  if (i != null && o != null && i !== o)
    return { keep: !0, reason: "sr-mismatch", srcWkid: i, candWkid: o };
  const c = t, l = e;
  try {
    if (!nr.execute(c, l))
      return { keep: !1, reason: "no-intersect", srcWkid: i, candWkid: o };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: i, candWkid: o };
  }
  let d;
  try {
    d = sn.execute(c, l);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: i, candWkid: o };
  }
  if (!d)
    return i != null && o != null && i === o ? { keep: !1, reason: "touch-no-area", srcWkid: i, candWkid: o, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: i, candWkid: o };
  const u = ot(d), p = ot(t), w = ot(e), b = Math.min(p, w), h = b > 0 ? u / b : 0, g = { srcWkid: i, candWkid: o, overlapAreaM2: u, sourceAreaM2: p, candidateAreaM2: w, ratio: h };
  return h >= s ? { keep: !0, reason: "ratio-pass", ...g } : u >= n ? { keep: !0, reason: "area-pass", ...g } : { keep: !1, reason: "below-threshold", ...g };
}
function Hs(t, e, r = {}) {
  return Ws(t, e, r).keep;
}
const er = {
  perMatrikkelenhet: /* @__PURE__ */ new Map(),
  utenMatrikkelenhet: []
}, K = { add: "add", remove: "remove" };
class li {
  constructor(e, r, n, s = "", i) {
    if (this.eiendomsLayerId = "Eiendommer", this.naboLayerId = "Naboer", this.activeOmradetype = "delomrade", this.savingCount = 0, this.avvikPort = i, this.mapView = e, this.token = r, this.apiUrl = n, this.eiendommerUrl = s, this.mapView.map) {
      if (!this.mapView.map.findLayerById(this.naboLayerId)) {
        const o = this.createClientSideFeatureLayer(e.spatialReference);
        o.blendMode = "normal", o.id = this.naboLayerId, o.popupEnabled = !1, this.mapView.map.add(o);
      }
      this.naboLayer = this.mapView.map.findLayerById(this.naboLayerId);
    }
    this.teiger = /* @__PURE__ */ new Map(), this.persistedAddedMatrikkelenhetIds = /* @__PURE__ */ new Set(), this.activeOmradeId = void 0;
  }
  async getIntersectingProperties(e, r, n) {
    await this.resetSelectionState(), console.log("Getting parts liste for graphics:", e);
    const s = e.map(async (h) => h.geometry ? it(n, h.geometry, r) : Promise.resolve(void 0)), i = await Promise.allSettled(s), o = this.getMatrikkelEnhetIds(i), c = this.getOmradeIds(e);
    this.activeOmradeId = c.at(0), this.activeOmradetype = this.getOmradetype(e);
    const l = this.avvikPort && o.length > 0 && c.length > 0 ? await this.avvikPort.hentDeltaerForOmråder(c, this.activeOmradetype) : er;
    this.persistedAddedMatrikkelenhetIds = this.getPersistedAddedMatrikkelenhetIds(l);
    const d = new Set(o), u = await this.fetchAddedMatrikkelenheterOutsideIntersecting(
      d,
      l
    ), { keepTeigIds: p, teigGeometryById: w } = await this.computeOverlappingTeiger(
      i,
      e
    );
    i.forEach((h) => {
      if (h.status === "fulfilled" && h.value) {
        for (const g of h.value)
          if (g.gardsnr !== 0) {
            if (p) {
              g.teigIds = (g.teigIds ?? []).filter((y) => p.has(y));
              for (const y of g.seksjoner ?? [])
                y.teigIds = (y.teigIds ?? []).filter((O) => p.has(O));
            }
            this.avvikPort?.anvendPåEnhetstre(g, l, "merge"), (g.teigIds?.length ?? 0) !== 0 && (this.setTeiger(g, !1), this.setTeiger(g.seksjoner, !1));
          }
      }
      h.status === "rejected" && console.log(`Error query matrikkelenhet from geometry, ${h.reason}`);
    });
    for (const h of u)
      h.gardsnr !== 0 && (this.avvikPort?.anvendPåEnhetstre(h, l, "kun-tillagte"), this.setTeiger(h, !1), this.setTeiger(h.seksjoner, !1));
    await this.addMatrikkelEnheterToMap([...this.teiger.keys()], "nabo", w), this.emitPropertiesChange([...new Set([...this.teiger.values()].flat())]);
    const b = e[0]?.geometry;
    if (b) {
      const h = b.type ? b : at.fromJSON(b);
      await this.mapView.goTo(h), this.flashGeometry(h);
    }
  }
  async resetSelectionState() {
    this.teiger.clear(), this.persistedAddedMatrikkelenhetIds.clear(), this.activeOmradeId = void 0, this.activeOmradetype = "delomrade";
    const e = await this.naboLayer.queryFeatures();
    e.features.length > 0 && await this.naboLayer.applyEdits({
      deleteFeatures: e.features
    });
  }
  getMatrikkelEnhetIds(e) {
    return e.map((n) => {
      if (!(n.status !== "fulfilled" || !n.value)) {
        for (const s of n.value)
          if (s.gardsnr !== 0)
            return s.matrikkelenhetId;
      }
    }).filter((n) => n !== void 0);
  }
  /**
   * Registrer React-callbacks. `onPropertiesChange` erstatter det gamle
   * window-eventet (kalles hver gang eiendomslista endres); `onSavingChange`
   * signaliserer at delta-skriving pågår, så UI-et kan vise «Lagrer…».
   */
  setListeners(e) {
    this.onPropertiesChange = e.onPropertiesChange, this.onSavingChange = e.onSavingChange;
  }
  /**
   * Kjør en lagre-operasjon med save-indikator. Teller nøstede/parallelle
   * lagringer så indikatoren først slås av når ALT er ferdig.
   */
  async runSaving(e) {
    this.savingCount++, this.savingCount === 1 && this.onSavingChange?.(!0);
    try {
      return await e();
    } finally {
      this.savingCount--, this.savingCount === 0 && this.onSavingChange?.(!1);
    }
  }
  async activatePropertySelector() {
    this.hitTestHandle || (this.hitTestHandle = this.mapView.on("click", (e) => this.handleClickEvent(e, this.mapView)));
  }
  deactivatePropertySelector() {
    this.hitTestHandle?.remove();
  }
  async clearSelection() {
    await this.resetSelectionState(), this.emitPropertiesChange([]);
  }
  /**
   * Load parcels purely from persisted "add" deltas (no spatial intersect).
   * Used for egendefinerte områder that have no geometry of their own.
   */
  async loadPersistedProperties(e, r = "egendefinert") {
    await this.resetSelectionState();
    const n = String(e);
    this.activeOmradeId = n, this.activeOmradetype = r;
    const s = this.avvikPort ? await this.avvikPort.hentDeltaerForOmråde(n, r) : er, i = await this.fetchAddedMatrikkelenheterOutsideIntersecting(
      /* @__PURE__ */ new Set(),
      s,
      !0
      // skip finnVedGeometri — deltas already carry matrikkelenhetId
    );
    for (const o of i)
      o.gardsnr !== 0 && (this.avvikPort?.anvendPåEnhetstre(o, s, "kun-tillagte"), this.setTeiger(o, !1), this.setTeiger(o.seksjoner, !1));
    await this.paintPersistedAddedDeltas(s), this.emitPropertiesChange([...new Set([...this.teiger.values()].flat())]);
  }
  /**
   * Paint polygons directly from the geometry stored on each add-delta in
   * eiendommer_v7. Used by loadPersistedProperties because legacy imports
   * lack teigId, so the teigId→geoeiendom refetch path returns nothing.
   */
  async paintPersistedAddedDeltas(e) {
    const r = this.mapView?.spatialReference, n = [], s = [], i = [...e.perMatrikkelenhet.values(), e.utenMatrikkelenhet];
    for (const o of i)
      for (const c of o) {
        if (c.operation !== K.add || !c.geometry)
          continue;
        const l = c.teigId ?? (c.deltaObjectId != null ? -c.deltaObjectId : void 0);
        if (l === void 0)
          continue;
        const d = c.geometry;
        r && (d.spatialReference = r), n.push(new et({
          geometry: d,
          attributes: { id: l, gids: String(l), type: "nabo" }
        })), s.push(d);
      }
    n.length !== 0 && (await this.naboLayer.applyEdits({ addFeatures: n }), this.mapView && s.length > 0 && await this.mapView.goTo(s, { duration: 400 }));
  }
  /**
   * Delete all eiendommer_v4 records for a given område.
   * Used for cleanup when an egendefinert område is deleted.
   */
  async deleteAllDeltasForOmrade(e, r) {
    if (this.avvikPort)
      try {
        await this.avvikPort.slettAlleForOmråde(String(e), r);
      } catch (n) {
        console.error("Failed to delete all deltas for område", e, n);
      }
  }
  gotoEiendom(e) {
    const r = e.teigIds;
    r && this.mapView.when(() => {
      const n = this.naboLayer.createQuery();
      n.where = this.constructWhereClause(r, "id"), this.naboLayer.queryFeatures(n).then((s) => {
        this.mapView.goTo(s.features);
      });
    });
  }
  async removeMatrikkelEnheter(e) {
    await this.runSaving(() => this.removeMatrikkelEnheterInner(e));
  }
  async removeMatrikkelEnheterInner(e) {
    const r = e.flatMap((u) => u.teigIds ?? []);
    if (r.length === 0)
      return;
    const n = this.naboLayer.createQuery();
    n.where = this.constructWhereClause(r, "id");
    const i = (await this.naboLayer.queryFeatures(n)).features, o = e.flatMap(
      (u) => (u.teigIds ?? []).flatMap((p) => {
        const w = i.find((b) => b.attributes.id === p);
        return w ? [{
          id: p,
          matrikkelenhetId: u.matrikkelenhetId,
          geometry: w.geometry
        }] : [];
      })
    );
    await this.addTeigDeltaToService(o, K.remove);
    const c = new Set(e.map((u) => u.matrikkelenhetId)), l = [];
    for (const u of new Set(r)) {
      const p = (this.teiger.get(u) ?? []).filter((w) => !c.has(w.matrikkelenhetId));
      p.length === 0 ? (this.teiger.delete(u), l.push(u)) : this.teiger.set(u, p);
    }
    if (l.length > 0) {
      const u = new Set(l);
      await this.deleteGraphics(i.filter((p) => u.has(p.attributes.id)));
    }
    const d = [...new Set([...this.teiger.values()].flat())];
    this.emitPropertiesChange(d);
  }
  /**
   * Invers av removeMatrikkelEnheter — legger matrikkelenhetene tilbake:
   * re-maler teigene, persisterer en «add»-delta som overstyrer den forrige
   * «remove»-deltaen, og gjenoppretter teiger-mappen. Brukes av angre-toasten
   * når saksbehandleren fjernet noe ved et uhell. Speiler add-grenen i
   * handleClickEvent (matrikkelenhet-nivå).
   */
  async addMatrikkelEnheter(e) {
    await this.runSaving(() => this.addMatrikkelEnheterInner(e));
  }
  async addMatrikkelEnheterInner(e) {
    const r = [...new Set(e.flatMap((l) => l.teigIds ?? []))];
    if (r.length === 0)
      return;
    await this.addMatrikkelEnheterToMap(r, "nabo");
    const n = this.naboLayer.createQuery();
    n.where = this.constructWhereClause(r, "id");
    const s = await this.naboLayer.queryFeatures(n), i = new Map(
      s.features.map((l) => [l.attributes.id, l.geometry])
    ), o = [];
    for (const l of e) {
      this.setTeiger(l, !1), this.setTeiger(l?.seksjoner, !0, l.teigIds);
      for (const d of l.teigIds ?? []) {
        const u = i.get(d);
        u && o.push({
          id: d,
          matrikkelenhetId: l.matrikkelenhetId,
          geometry: u
        });
      }
    }
    await this.addTeigDeltaToService(o, K.add);
    const c = [...new Set([...this.teiger.values()].flat())];
    this.emitPropertiesChange(c);
  }
  async handleClickEvent(e, r) {
    await this.runSaving(() => this.handleClickEventInner(e, r));
  }
  async handleClickEventInner(e, r) {
    const n = e.mapPoint, s = await r.hitTest(e);
    if (this.isHovedEiendom(s.results))
      return;
    let i = await this.getNaboerFromHitResults(s.results);
    if (i = i.filter((c) => nr.execute(n, c.geometry)), i.length > 0)
      if (!!e.native?.shiftKey) {
        const l = i[0].attributes.id, d = this.teiger.get(l) ?? [], u = [...new Set(d.flatMap((g) => g.teigIds ?? []))], p = this.naboLayer.createQuery();
        p.where = this.constructWhereClause(u, "id");
        const w = await this.naboLayer.queryFeatures(p);
        await this.deleteGraphics(w.features);
        const b = new Map(
          w.features.map((g) => [g.attributes.id, g.geometry])
        ), h = d.flatMap(
          (g) => (g.teigIds ?? []).map((y) => ({
            id: y,
            matrikkelenhetId: g.matrikkelenhetId,
            geometry: b.get(y) ?? i[0].geometry
          }))
        );
        await this.addTeigDeltaToService(h, K.remove), u.forEach((g) => this.teiger.delete(g));
      } else {
        const l = i.map((u) => u.attributes.id);
        await this.deleteGraphics(i);
        const d = l.flatMap((u) => this.teiger.get(u)?.map((w) => ({
          id: u,
          matrikkelenhetId: w.matrikkelenhetId,
          geometry: i.find((b) => b.attributes.id === u)?.geometry
        })) ?? []);
        await this.addTeigDeltaToService(d, K.remove), l.forEach((u) => this.teiger.delete(u));
      }
    else {
      const c = !!e.native?.shiftKey, l = await it(this.apiUrl, n, this.token);
      if (l.length === 0)
        return;
      if (c) {
        const d = [...new Set(l.flatMap((E) => E.teigIds ?? []))], u = this.naboLayer.createQuery();
        u.where = this.constructWhereClause(d, "id");
        const p = await this.naboLayer.queryFeatures(u), w = new Set(p.features.map((E) => E.attributes.id)), b = d.filter((E) => !w.has(E));
        b.length > 0 && await this.addMatrikkelEnheterToMap(b, "nabo");
        const h = this.naboLayer.createQuery();
        h.where = this.constructWhereClause(d, "id");
        const g = await this.naboLayer.queryFeatures(h), y = new Map(
          g.features.map((E) => [E.attributes.id, E.geometry])
        ), O = [];
        for (const E of l) {
          this.setTeiger(E, !1), this.setTeiger(E?.seksjoner, !0, E.teigIds);
          for (const P of E.teigIds ?? []) {
            const x = y.get(P);
            x && O.push({
              id: P,
              matrikkelenhetId: E.matrikkelenhetId,
              geometry: x
            });
          }
        }
        await this.addTeigDeltaToService(O, K.add);
      } else {
        const d = await this.getNabokandidaterFromHitResults(s.results);
        if (d.length === 0)
          return;
        await this.addGraphics(d, "nabo");
        const u = d[0].attributes.id, p = d[0].geometry, w = [];
        for (const b of l) {
          if (!(b.teigIds ?? []).includes(u))
            continue;
          const h = [b, ...b.seksjoner ?? []];
          for (const g of h) {
            const y = { ...g, teigIds: [u], seksjoner: [] };
            this.setTeiger(y, !1), w.push({
              id: u,
              matrikkelenhetId: g.matrikkelenhetId,
              geometry: p
            });
          }
        }
        await this.addTeigDeltaToService(w, K.add);
      }
    }
    const o = [...new Set([...this.teiger.values()].flat())];
    this.emitPropertiesChange(o);
  }
  /**
   * Idempotent, tilstandsbasert skriving mot eiendommer_v7. En delta er et AVVIK
   * fra den geometriske baselinen (hva delområdet/planen selv overlapper):
   *   - fjerning av en enhet INNENFOR geometrien  → `remove`
   *   - tillegg av en enhet UTENFOR geometrien     → `add`
   *   - «tilbake til default»                        → INGEN rad (fravær = følg geometri)
   *
   * For hver relasjon (teigId, matrikkelenhetId, omradeid, omradetype) spørres
   * tjenesten om eksisterende rad(er):
   *   - samme operasjon finnes allerede → no-op (rydd evt. duplikater)
   *   - MOTSATT operasjon finnes         → slett den, skriv INGEN ny (default igjen)
   *   - ingen rad                        → skriv den nye (ekte avvik)
   *
   * Resultatet er at tabellen kun inneholder ekte avvik, maks én rad per relasjon,
   * uavhengig av økt-state. «Motsatt finnes»-grenen utnytter at eksistensen av en
   * motsatt rad impliserer enhetens baseline, så vi trenger ikke kjenne geometrien
   * her.
   */
  async addTeigDeltaToService(e, r) {
    const n = e.filter((s) => s !== void 0);
    if (n.length !== 0) {
      if (!this.avvikPort) {
        console.warn(`avvikPort er ikke injisert. Hopper over ${r} delta-skriving.`);
        return;
      }
      if (this.activeOmradeId == null || String(this.activeOmradeId).trim() === "") {
        console.warn(`activeOmradeId mangler — hopper over ${r} delta-skriving (unngår rad uten omradeid).`);
        return;
      }
      for (const s of n)
        await this.avvikPort.settAvvik({
          teigId: s.id,
          matrikkelenhetId: s.matrikkelenhetId,
          omradeId: this.activeOmradeId,
          omradetype: this.activeOmradetype,
          operation: r,
          geometry: s.geometry
        });
    }
  }
  async fetchAddedMatrikkelenheterOutsideIntersecting(e, r, n = !1) {
    const s = [...r.perMatrikkelenhet.entries()].filter(
      ([c, l]) => !e.has(c) && l.some((d) => d.operation === K.add)
    ).map(([c]) => c);
    if (s.length === 0)
      return [];
    const i = s.map(async (c) => {
      try {
        if (!n) {
          const p = (r.perMatrikkelenhet.get(c) ?? []).filter(
            (w) => w.operation === K.add && w.geometry
          );
          for (const w of p) {
            const b = [];
            w.geometry?.extent?.center && b.push(w.geometry.extent.center), w.geometry && b.push(w.geometry);
            let h;
            for (const g of b) {
              const y = await it(this.apiUrl, g, this.token);
              if (!(!Array.isArray(y) || y.length === 0) && (h = this.findMatrikkelenhetById(y, c), h))
                break;
            }
            if (h)
              return await this.enrichAdresseIfMissing(h, c), h;
          }
        }
        const l = await Xt(this.apiUrl, c, this.token), d = this.normalizeMatrikkelEnhetFromQueryResponse(l, c);
        if (d)
          return await this.enrichAdresseIfMissing(d, c), d;
      } catch (l) {
        console.error(`Failed to fetch matrikkelenhet ${c} from geoeiendom`, l);
      }
    });
    return (await Promise.all(i)).filter((c) => c !== void 0);
  }
  normalizeMatrikkelEnhetFromQueryResponse(e, r) {
    if (e) {
      if (typeof e == "object" && e.matrikkelenhetId === r)
        return e;
      if (Array.isArray(e))
        return e.find((n) => n?.matrikkelenhetId === r);
      if (Array.isArray(e.eiendommer))
        return e.eiendommer.find((n) => n?.matrikkelenhetId === r);
    }
  }
  async enrichAdresseIfMissing(e, r) {
    if (e.adresse)
      return;
    const n = await this.fetchAdresseForMatrikkelenhetId(r);
    n && (e.adresse = n);
  }
  async fetchAdresseForMatrikkelenhetId(e) {
    try {
      const r = await Xt(this.apiUrl, e, this.token, "adresse");
      return this.extractAdresse(r);
    } catch {
      return;
    }
  }
  extractAdresse(e) {
    if (e) {
      if (typeof e == "number")
        return Number.isFinite(e) ? String(e) : void 0;
      if (typeof e == "string") {
        const r = e.trim();
        return r.length > 0 ? r : void 0;
      }
      if (Array.isArray(e)) {
        for (const r of e) {
          const n = this.extractAdresse(r);
          if (n)
            return n;
        }
        return;
      }
      if (typeof e == "object") {
        const r = e, n = this.composeAdresseFromParts(r);
        if (n)
          return n;
        const s = ["adresse", "adressetekst", "adresseTekst", "fullAdresse", "vegadresse"];
        for (const o of s) {
          const c = this.extractAdresse(r[o]);
          if (c)
            return c;
        }
        const i = ["adresser", "adresseListe", "adresseList", "eiendommer", "results", "items"];
        for (const o of i) {
          const c = this.extractAdresse(r[o]);
          if (c)
            return c;
        }
      }
    }
  }
  composeAdresseFromParts(e) {
    const r = this.extractAdresse(
      e.adressenavn ?? e.vegnavn ?? e.gatenavn ?? e.streetName ?? e.street
    ), n = this.extractAdresse(
      e.husnummer ?? e.houseNumber ?? e.nummer ?? e.nr
    ), s = this.extractAdresse(
      e.undernummer ?? e.subNumber ?? e.underNr
    ), i = this.extractAdresse(
      e.husbokstav ?? e.bokstav ?? e.letter ?? e.houseLetter
    ), c = `${`${n ?? ""}${s ?? ""}`.trim()}${i ?? ""}`.trim();
    if (!(!r && !c))
      return r ? c ? `${r} ${c}` : r : c;
  }
  findMatrikkelenhetById(e, r, n) {
    for (const s of e) {
      const i = s.adresse ?? n;
      if (s.matrikkelenhetId === r)
        return !s.adresse && i && (s.adresse = i), s;
      if (Array.isArray(s.seksjoner) && s.seksjoner.length > 0) {
        const o = this.findMatrikkelenhetById(s.seksjoner, r, i);
        if (o)
          return o;
      }
    }
  }
  /**
   * Henter den stabile koblingsnøkkelen pr. graphic. Den faktiske derivasjonen
   * (LOKALID || `OBJTYPE:OBJECTID`-komposit for delomrader, eller stringifisert
   * Områder-id for egendefinerte) gjøres oppstrøms i admin (se
   * `selectedPlanGeometrySlice.ts` og `AdminPage.handleSelect`). Her er
   * `attrs.omradeid` allerede den ferdige strengen — vi stoler på det og
   * stringifiserer for sikkerhets skyld (legacy-data kan være nummer).
   */
  getOmradeIds(e) {
    const r = e.map((n) => {
      const i = n.attributes?.omradeid;
      if (i == null)
        return;
      const o = String(i).trim();
      return o === "" ? void 0 : o;
    }).filter((n) => n !== void 0);
    return [...new Set(r)];
  }
  /**
   * Leser områdetypen fra graphic-attributtene (admin setter den per nivå:
   * 'plan' | 'delomrade' | 'delomradegruppe' | 'egendefinert'). Brukes som
   * `omradetype`-felt ved persistering og i where-klausuler. Defaulter til
   * 'delomrade' når den mangler (legacy/bakoverkompatibilitet).
   */
  getOmradetype(e) {
    for (const r of e) {
      const s = r.attributes?.omradetype;
      if (typeof s == "string" && s.trim() !== "")
        return s.trim();
    }
    return "delomrade";
  }
  getPersistedAddedMatrikkelenhetIds(e) {
    const r = /* @__PURE__ */ new Set();
    for (const [n, s] of e.perMatrikkelenhet.entries())
      s.some((i) => i.operation === K.add) && r.add(n);
    return r;
  }
  /**
   * Bygg WHERE-klausulen som identifiserer ALLE rader for én relasjon
   * (teigId, matrikkelenhetId, omradeid, omradetype) — uavhengig av operation.
   * Brukes av den idempotente skrivingen for å finne eksisterende rader.
   */
  setTeiger(e, r, n = []) {
    if (e == null)
      return;
    (Array.isArray(e) ? e : [e]).forEach((i) => {
      i.teigIds?.forEach((o) => {
        if (!r || n.includes(o)) {
          const c = this.teiger.get(o);
          c ? this.teiger.set(o, [...c, i]) : this.teiger.set(o, [i]);
        }
      });
    });
  }
  isHovedEiendom(e) {
    return e.filter(
      (n) => n.type === "graphic" && n.graphic.layer === this.naboLayer && n.graphic.attributes.type === "hovedeiendom"
    ).map((n) => n).length >= 1;
  }
  /**
   * Bygg settet av teiger som overlapper kilde-geometrien (det valgte
   * delområdet) med et reelt areal. Returnerer `keepTeigIds: null` når
   * filtrering ikke er mulig (mangler kilde-geometri eller SR) — da beholdes
   * alt (fail-open). `teigGeometryById` gjenbrukes av `addMatrikkelEnheterToMap`
   * så geometriene ikke hentes to ganger.
   */
  async computeOverlappingTeiger(e, r) {
    const n = r.map((p) => p.geometry).filter((p) => !!p).map((p) => p.type ? p : at.fromJSON(p)), s = /* @__PURE__ */ new Set();
    for (const p of e)
      if (!(p.status !== "fulfilled" || !p.value)) {
        for (const w of p.value)
          if (w.gardsnr !== 0) {
            for (const b of w.teigIds ?? [])
              s.add(b);
            for (const b of w.seksjoner ?? [])
              for (const h of b.teigIds ?? [])
                s.add(h);
          }
      }
    const i = this.mapView?.spatialReference, o = i?.wkid;
    if (n.length === 0 || !i || o == null || s.size === 0)
      return { keepTeigIds: null, teigGeometryById: /* @__PURE__ */ new Map() };
    if (!tt.isLoaded())
      try {
        await tt.load();
      } catch (p) {
        console.warn("Kunne ikke laste projectOperator for overlapp-filter", p);
      }
    const c = n.map((p) => {
      if (p.spatialReference?.wkid === o)
        return p;
      try {
        return tt.execute(p, i) ?? p;
      } catch {
        return p;
      }
    }), l = await Qt(this.apiUrl, [...s], o, this.token), d = new Map(l.map((p) => [p.teigId, p.polygon])), u = /* @__PURE__ */ new Set();
    for (const { teigId: p, polygon: w } of l)
      c.some((b) => Hs(b, w)) && u.add(p);
    for (const p of s)
      d.has(p) || u.add(p);
    return { keepTeigIds: u, teigGeometryById: d };
  }
  async addMatrikkelEnheterToMap(e, r, n) {
    if (!e || e.length === 0)
      return;
    const s = this.mapView.spatialReference.wkid;
    if (s == null)
      return;
    const i = new Map(n ?? []), o = e.filter((l) => !i.has(l));
    if (o.length > 0) {
      const l = await Qt(this.apiUrl, o, s, this.token);
      for (const { teigId: d, polygon: u } of l)
        i.set(d, u);
    }
    const c = e.map((l) => {
      const d = i.get(l);
      return d ? new et({ geometry: d, attributes: { id: l, gids: String(l) } }) : null;
    }).filter((l) => l !== null);
    await this.addGraphics(c, r);
  }
  async addGraphics(e, r) {
    for (const n of e)
      n.attributes.type = r;
    if (e.length > 0) {
      const s = ((await this.naboLayer.applyEdits({ addFeatures: e }))?.addFeatureResults ?? []).filter((i) => i?.error);
      if (s.length > 0) {
        const i = s[0]?.error?.message;
        console.warn(`[NaboListeService] applyEdits avviste ${s.length}/${e.length} grafikker:`, i);
      }
    }
  }
  async deleteGraphics(e) {
    e.length > 0 && await this.naboLayer.applyEdits({
      deleteFeatures: e
    });
  }
  async getNaboerFromHitResults(e) {
    return e.filter(
      (r) => r.type === "graphic" && r.graphic.layer === this.naboLayer && r.graphic.attributes.type === "nabo"
    ).map((r) => r.graphic);
  }
  async getNabokandidaterFromHitResults(e) {
    const r = await this.getEiendomsLayer();
    return e.filter(
      (n) => n.type === "graphic" && n.graphic.layer === r
    ).map((n) => n.graphic);
  }
  async getEiendomsLayer() {
    if (this.eiendomslayer)
      return this.eiendomslayer;
    await rn(() => !this.mapView.updating);
    const e = this.mapView;
    if (!e.map)
      throw new Error("Map is not initialized.");
    return e.map.findLayerById(this.eiendomsLayerId);
  }
  createClientSideFeatureLayer(e) {
    const r = new Ze({
      color: [60, 120, 120, 0.35],
      outline: { color: [60, 120, 120, 1], width: 2 }
    }), n = new Ze({
      color: [120, 240, 240, 0.35],
      outline: { color: [120, 240, 240, 1], width: 2 }
    });
    return new en({
      title: "Naboer",
      source: [],
      geometryType: "polygon",
      spatialReference: e,
      objectIdField: "objectId",
      outFields: ["*"],
      popupTemplate: {
        content: (s) => s.graphic.attributes.type
      },
      renderer: new tn({
        field: "type",
        uniqueValueInfos: [{
          value: "nabo",
          symbol: n
        }, {
          value: "hovedeiendom",
          symbol: r
        }]
      }),
      fields: [{
        name: "objectId",
        type: "oid"
      }, {
        name: "gids",
        type: "string"
      }, {
        // teigId (matrikkel) overstiger 32-bit (esriFieldTypeInteger, maks
        // 2 147 483 647) — moderne teigId-er er ~6,5 mrd. Med "integer" avviste
        // applyEdits stille alle grafikker med stor teigId, så de havnet i lista
        // men ble aldri malt. "big-integer" (64-bit) rommer dem.
        name: "id",
        type: "big-integer"
      }, {
        name: "type",
        type: "string"
      }]
    });
  }
  constructWhereClause(e, r) {
    return e.length === 1 ? `${r}=${e[0]}` : `${r} IN (${e.join(",")})`;
  }
  flashGeometry(e) {
    const r = new Ze({
      color: [0, 0, 0, 0],
      outline: { color: [255, 0, 255, 255], width: 3 }
    }), n = new et({ geometry: e, symbol: r }), s = () => this.mapView.graphics.add(n), i = () => this.mapView.graphics.remove(n);
    s(), setTimeout(i, 350), setTimeout(s, 700), setTimeout(i, 1050);
  }
  /** Varsle React-laget om at eiendomslista er endret (erstatter tidligere window-event). */
  emitPropertiesChange(e) {
    this.onPropertiesChange?.(e);
  }
}
class Vs {
  constructor() {
    this.tokenInfo = void 0, this.tokenFeatureLayer = void 0;
  }
  async getToken() {
    return this.tokenFeatureLayer || (this.tokenFeatureLayer = await this.getTokenLayer()), this.isTokenInfoValid(this.tokenInfo) || (this.tokenInfo = await this.getTokenInfo()), this.tokenInfo?.token;
  }
  async getTokenInfo() {
    if (this.tokenFeatureLayer) {
      const r = (await this.tokenFeatureLayer.queryFeatures({
        returnGeometry: !1,
        outFields: ["*"]
      })).features[0];
      return {
        token: r.attributes.token,
        expires: new Date(r.attributes.expires)
      };
    }
  }
  isTokenInfoValid(e) {
    if (e == null)
      return !1;
    const r = e.expires.getTime() - (/* @__PURE__ */ new Date()).getTime(), n = 1e3 * 60 * 5;
    return r >= n;
  }
  async getTokenLayer() {
    if (this.tokenFeatureLayer)
      return this.tokenFeatureLayer;
    let e = new an({
      id: "7159c11acc8049cd9b618fdc3650570a"
    });
    return await on.fromPortalItem({
      portalItem: e
    });
  }
}
const ui = new Vs();
class Gs {
  constructor(e) {
    this.config = e;
  }
  /**
   * Get authentication token
   * @throws Error if no token is available
   */
  async getToken() {
    const e = await this.config.getToken();
    if (!e)
      throw new Error("No authentication token available");
    return e;
  }
  /**
   * Get MatrikkelEnhet from geometry
   */
  async getMatrikkelEnhetFromGeometry(e) {
    const r = await this.getToken(), n = `${this.config.apiUrl}/Matrikkelenhet/finnvedgeometri`;
    try {
      return (await Y.post(
        `${n}?Token=${r}`,
        { geometry: e },
        {
          timeout: this.config.timeout || 3e4,
          headers: {
            "Content-Type": "application/json"
          }
        }
      )).data.eiendommer;
    } catch (s) {
      throw console.error("Error fetching MatrikkelEnhet from geometry:", s), s;
    }
  }
  /**
   * Query MatrikkelEnhet by ID
   */
  async queryMatrikkelenhet(e, r, n) {
    const s = await this.getToken(), i = `${this.config.apiUrl}/matrikkelenhet/${e}${r ? "/" + r : ""}`;
    try {
      return (await Y.get(i, {
        params: { token: s },
        timeout: this.config.timeout || 3e4,
        signal: n?.signal
      })).data;
    } catch (o) {
      throw Y.isCancel(o) ? o : (console.error("Error querying MatrikkelEnhet:", o), new Error("Feil med henting av matrikkelinformasjon. Prøv igjen."));
    }
  }
  /**
   * Matrikkelenhetene en vegadresse er knyttet til (adresse/{id}/matrikkelenhet).
   * For adresser på seksjonerte eiendommer inneholder listen typisk både
   * grunneiendommen og matrikkelseksjonen(e) — brukes av publikums
   * identitetsberikelse (F21).
   */
  async getMatrikkelenheterForAdresse(e, r) {
    const n = await this.getToken(), s = `${this.config.apiUrl}/adresse/${e}/matrikkelenhet`;
    try {
      return (await Y.get(s, {
        params: { token: n },
        timeout: this.config.timeout || 3e4,
        signal: r?.signal
      })).data?.matrikkelenheter ?? [];
    } catch (i) {
      throw Y.isCancel(i) ? i : (console.error("Error fetching matrikkelenheter for adresse:", i), new Error("Failed to get matrikkelenheter for adresse"));
    }
  }
  /**
   * Fetch all street addresses for a matrikkelenhet (handles units with multiple addresses)
   */
  async getAllAdresser(e) {
    const r = await this.queryMatrikkelenhet(e, "adresse");
    return qs(r);
  }
  /**
   * Get MatrikkelEnhet ID from matrikkel numbers
   */
  async getMatrikkelEnhetId(e, r, n, s = 0, i = 0, o) {
    const c = await this.getToken(), l = `${this.config.apiUrl}/Matrikkelenhet/matrikkelenhetid`;
    try {
      return (await Y.get(l, {
        params: {
          Kommunenummer: e,
          Gardsnummer: r,
          Bruksnummer: n,
          Festenummer: s,
          Seksjonsnummer: i,
          token: c
        },
        timeout: this.config.timeout || 3e4,
        signal: o?.signal
      })).data.matrikkelenhetId;
    } catch (d) {
      throw Y.isCancel(d) ? d : (console.error("Error getting MatrikkelEnhetId:", d), new Error("Failed to get matrikkelEnhetId"));
    }
  }
  /**
   * Open Matrikkel rapport in new window
   */
  async openMatrikkelrapport(e) {
    try {
      const r = await this.getToken(), n = `${this.config.apiUrl}/matrikkelenhet/${e}/rapport?token=${r}`;
      window.open(n);
    } catch (r) {
      console.error("Error opening Matrikkelrapport:", r);
    }
  }
  /**
   * Open Grunnbok rapport in new window
   */
  async openGrunnbokrapport(e) {
    try {
      const r = await this.getToken(), n = `${this.config.apiUrl}/grunnbok/kartverket/rapport?kommunenummer=${e.knr}&gardsnummer=${e.gnr}&bruksnummer=${e.bnr}&festenummer=${e.fnr}&seksjonsnummer=${e.snr}&token=${r}`;
      window.open(n);
    } catch (r) {
      console.error("Error opening Grunnbokrapport:", r);
    }
  }
}
const fi = (t) => new Gs(t);
var dt = { exports: {} }, ke = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tr;
function zs() {
  if (tr)
    return ke;
  tr = 1;
  var t = sr, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(c, l, d) {
    var u, p = {}, w = null, b = null;
    d !== void 0 && (w = "" + d), l.key !== void 0 && (w = "" + l.key), l.ref !== void 0 && (b = l.ref);
    for (u in l)
      n.call(l, u) && !i.hasOwnProperty(u) && (p[u] = l[u]);
    if (c && c.defaultProps)
      for (u in l = c.defaultProps, l)
        p[u] === void 0 && (p[u] = l[u]);
    return { $$typeof: e, type: c, key: w, ref: b, props: p, _owner: s.current };
  }
  return ke.Fragment = r, ke.jsx = o, ke.jsxs = o, ke;
}
var we = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rr;
function Js() {
  return rr || (rr = 1, process.env.NODE_ENV !== "production" && function() {
    var t = sr, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), h = Symbol.iterator, g = "@@iterator";
    function y(a) {
      if (a === null || typeof a != "object")
        return null;
      var m = h && a[h] || a[g];
      return typeof m == "function" ? m : null;
    }
    var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(a) {
      {
        for (var m = arguments.length, k = new Array(m > 1 ? m - 1 : 0), v = 1; v < m; v++)
          k[v - 1] = arguments[v];
        P("error", a, k);
      }
    }
    function P(a, m, k) {
      {
        var v = O.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (m += "%s", k = k.concat([A]));
        var C = k.map(function(R) {
          return String(R);
        });
        C.unshift("Warning: " + m), Function.prototype.apply.call(console[a], console, C);
      }
    }
    var x = !1, B = !1, X = !1, D = !1, de = !1, ee;
    ee = Symbol.for("react.module.reference");
    function Se(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === i || de || a === s || a === d || a === u || D || a === b || x || B || X || typeof a == "object" && a !== null && (a.$$typeof === w || a.$$typeof === p || a.$$typeof === o || a.$$typeof === c || a.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === ee || a.getModuleId !== void 0));
    }
    function Te(a, m, k) {
      var v = a.displayName;
      if (v)
        return v;
      var A = m.displayName || m.name || "";
      return A !== "" ? k + "(" + A + ")" : k;
    }
    function te(a) {
      return a.displayName || "Context";
    }
    function j(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case c:
            var m = a;
            return te(m) + ".Consumer";
          case o:
            var k = a;
            return te(k._context) + ".Provider";
          case l:
            return Te(a, a.render, "ForwardRef");
          case p:
            var v = a.displayName || null;
            return v !== null ? v : j(a.type) || "Memo";
          case w: {
            var A = a, C = A._payload, R = A._init;
            try {
              return j(R(C));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, Z = 0, q, he, H, pe, Re, V, Q;
    function ie() {
    }
    ie.__reactDisabledLog = !0;
    function oe() {
      {
        if (Z === 0) {
          q = console.log, he = console.info, H = console.warn, pe = console.error, Re = console.group, V = console.groupCollapsed, Q = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: ie,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        Z++;
      }
    }
    function Oe() {
      {
        if (Z--, Z === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, a, {
              value: q
            }),
            info: L({}, a, {
              value: he
            }),
            warn: L({}, a, {
              value: H
            }),
            error: L({}, a, {
              value: pe
            }),
            group: L({}, a, {
              value: Re
            }),
            groupCollapsed: L({}, a, {
              value: V
            }),
            groupEnd: L({}, a, {
              value: Q
            })
          });
        }
        Z < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var He = O.ReactCurrentDispatcher, Ve;
    function Ae(a, m, k) {
      {
        if (Ve === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Ve = v && v[1] || "";
          }
        return `
` + Ve + a;
      }
    }
    var Ge = !1, Ce;
    {
      var Pr = typeof WeakMap == "function" ? WeakMap : Map;
      Ce = new Pr();
    }
    function vt(a, m) {
      if (!a || Ge)
        return "";
      {
        var k = Ce.get(a);
        if (k !== void 0)
          return k;
      }
      var v;
      Ge = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var C;
      C = He.current, He.current = null, oe();
      try {
        if (m) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch ($) {
              v = $;
            }
            Reflect.construct(a, [], R);
          } else {
            try {
              R.call();
            } catch ($) {
              v = $;
            }
            a.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch ($) {
            v = $;
          }
          a();
        }
      } catch ($) {
        if ($ && v && typeof $.stack == "string") {
          for (var T = $.stack.split(`
`), N = v.stack.split(`
`), I = T.length - 1, F = N.length - 1; I >= 1 && F >= 0 && T[I] !== N[F]; )
            F--;
          for (; I >= 1 && F >= 0; I--, F--)
            if (T[I] !== N[F]) {
              if (I !== 1 || F !== 1)
                do
                  if (I--, F--, F < 0 || T[I] !== N[F]) {
                    var W = `
` + T[I].replace(" at new ", " at ");
                    return a.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", a.displayName)), typeof a == "function" && Ce.set(a, W), W;
                  }
                while (I >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        Ge = !1, He.current = C, Oe(), Error.prepareStackTrace = A;
      }
      var ce = a ? a.displayName || a.name : "", re = ce ? Ae(ce) : "";
      return typeof a == "function" && Ce.set(a, re), re;
    }
    function Ir(a, m, k) {
      return vt(a, !1);
    }
    function Fr(a) {
      var m = a.prototype;
      return !!(m && m.isReactComponent);
    }
    function Pe(a, m, k) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return vt(a, Fr(a));
      if (typeof a == "string")
        return Ae(a);
      switch (a) {
        case d:
          return Ae("Suspense");
        case u:
          return Ae("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case l:
            return Ir(a.render);
          case p:
            return Pe(a.type, m, k);
          case w: {
            var v = a, A = v._payload, C = v._init;
            try {
              return Pe(C(A), m, k);
            } catch {
            }
          }
        }
      return "";
    }
    var me = Object.prototype.hasOwnProperty, Et = {}, St = O.ReactDebugCurrentFrame;
    function Ie(a) {
      if (a) {
        var m = a._owner, k = Pe(a.type, a._source, m ? m.type : null);
        St.setExtraStackFrame(k);
      } else
        St.setExtraStackFrame(null);
    }
    function _r(a, m, k, v, A) {
      {
        var C = Function.call.bind(me);
        for (var R in a)
          if (C(a, R)) {
            var T = void 0;
            try {
              if (typeof a[R] != "function") {
                var N = Error((v || "React class") + ": " + k + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw N.name = "Invariant Violation", N;
              }
              T = a[R](m, R, v, k, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I) {
              T = I;
            }
            T && !(T instanceof Error) && (Ie(A), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", k, R, typeof T), Ie(null)), T instanceof Error && !(T.message in Et) && (Et[T.message] = !0, Ie(A), E("Failed %s type: %s", k, T.message), Ie(null));
          }
      }
    }
    var xr = Array.isArray;
    function ze(a) {
      return xr(a);
    }
    function jr(a) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, k = m && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return k;
      }
    }
    function Mr(a) {
      try {
        return Tt(a), !1;
      } catch {
        return !0;
      }
    }
    function Tt(a) {
      return "" + a;
    }
    function Rt(a) {
      if (Mr(a))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", jr(a)), Tt(a);
    }
    var ge = O.ReactCurrentOwner, Lr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ot, At, Je;
    Je = {};
    function Nr(a) {
      if (me.call(a, "ref")) {
        var m = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function Dr(a) {
      if (me.call(a, "key")) {
        var m = Object.getOwnPropertyDescriptor(a, "key").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function $r(a, m) {
      if (typeof a.ref == "string" && ge.current && m && ge.current.stateNode !== m) {
        var k = j(ge.current.type);
        Je[k] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(ge.current.type), a.ref), Je[k] = !0);
      }
    }
    function Ur(a, m) {
      {
        var k = function() {
          Ot || (Ot = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        k.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: k,
          configurable: !0
        });
      }
    }
    function Br(a, m) {
      {
        var k = function() {
          At || (At = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        k.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: k,
          configurable: !0
        });
      }
    }
    var qr = function(a, m, k, v, A, C, R) {
      var T = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: a,
        key: m,
        ref: k,
        props: R,
        // Record the component responsible for creating this element.
        _owner: C
      };
      return T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(T, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(T, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    };
    function Wr(a, m, k, v, A) {
      {
        var C, R = {}, T = null, N = null;
        k !== void 0 && (Rt(k), T = "" + k), Dr(m) && (Rt(m.key), T = "" + m.key), Nr(m) && (N = m.ref, $r(m, A));
        for (C in m)
          me.call(m, C) && !Lr.hasOwnProperty(C) && (R[C] = m[C]);
        if (a && a.defaultProps) {
          var I = a.defaultProps;
          for (C in I)
            R[C] === void 0 && (R[C] = I[C]);
        }
        if (T || N) {
          var F = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          T && Ur(R, F), N && Br(R, F);
        }
        return qr(a, T, N, A, v, ge.current, R);
      }
    }
    var Ke = O.ReactCurrentOwner, Ct = O.ReactDebugCurrentFrame;
    function ae(a) {
      if (a) {
        var m = a._owner, k = Pe(a.type, a._source, m ? m.type : null);
        Ct.setExtraStackFrame(k);
      } else
        Ct.setExtraStackFrame(null);
    }
    var Ye;
    Ye = !1;
    function Xe(a) {
      return typeof a == "object" && a !== null && a.$$typeof === e;
    }
    function Pt() {
      {
        if (Ke.current) {
          var a = j(Ke.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function Hr(a) {
      {
        if (a !== void 0) {
          var m = a.fileName.replace(/^.*[\\\/]/, ""), k = a.lineNumber;
          return `

Check your code at ` + m + ":" + k + ".";
        }
        return "";
      }
    }
    var It = {};
    function Vr(a) {
      {
        var m = Pt();
        if (!m) {
          var k = typeof a == "string" ? a : a.displayName || a.name;
          k && (m = `

Check the top-level render call using <` + k + ">.");
        }
        return m;
      }
    }
    function Ft(a, m) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var k = Vr(m);
        if (It[k])
          return;
        It[k] = !0;
        var v = "";
        a && a._owner && a._owner !== Ke.current && (v = " It was passed a child from " + j(a._owner.type) + "."), ae(a), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', k, v), ae(null);
      }
    }
    function _t(a, m) {
      {
        if (typeof a != "object")
          return;
        if (ze(a))
          for (var k = 0; k < a.length; k++) {
            var v = a[k];
            Xe(v) && Ft(v, m);
          }
        else if (Xe(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var A = y(a);
          if (typeof A == "function" && A !== a.entries)
            for (var C = A.call(a), R; !(R = C.next()).done; )
              Xe(R.value) && Ft(R.value, m);
        }
      }
    }
    function Gr(a) {
      {
        var m = a.type;
        if (m == null || typeof m == "string")
          return;
        var k;
        if (typeof m == "function")
          k = m.propTypes;
        else if (typeof m == "object" && (m.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        m.$$typeof === p))
          k = m.propTypes;
        else
          return;
        if (k) {
          var v = j(m);
          _r(k, a.props, "prop", v, a);
        } else if (m.PropTypes !== void 0 && !Ye) {
          Ye = !0;
          var A = j(m);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof m.getDefaultProps == "function" && !m.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zr(a) {
      {
        for (var m = Object.keys(a.props), k = 0; k < m.length; k++) {
          var v = m[k];
          if (v !== "children" && v !== "key") {
            ae(a), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), ae(null);
            break;
          }
        }
        a.ref !== null && (ae(a), E("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    var xt = {};
    function jt(a, m, k, v, A, C) {
      {
        var R = Se(a);
        if (!R) {
          var T = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (T += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var N = Hr(A);
          N ? T += N : T += Pt();
          var I;
          a === null ? I = "null" : ze(a) ? I = "array" : a !== void 0 && a.$$typeof === e ? (I = "<" + (j(a.type) || "Unknown") + " />", T = " Did you accidentally export a JSX literal instead of a component?") : I = typeof a, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, T);
        }
        var F = Wr(a, m, k, A, C);
        if (F == null)
          return F;
        if (R) {
          var W = m.children;
          if (W !== void 0)
            if (v)
              if (ze(W)) {
                for (var ce = 0; ce < W.length; ce++)
                  _t(W[ce], a);
                Object.freeze && Object.freeze(W);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _t(W, a);
        }
        if (me.call(m, "key")) {
          var re = j(a), $ = Object.keys(m).filter(function(Zr) {
            return Zr !== "key";
          }), Qe = $.length > 0 ? "{key: someKey, " + $.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xt[re + Qe]) {
            var Qr = $.length > 0 ? "{" + $.join(": ..., ") + ": ...}" : "{}";
            E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Qe, re, Qr, re), xt[re + Qe] = !0;
          }
        }
        return a === n ? zr(F) : Gr(F), F;
      }
    }
    function Jr(a, m, k) {
      return jt(a, m, k, !0);
    }
    function Kr(a, m, k) {
      return jt(a, m, k, !1);
    }
    var Yr = Kr, Xr = Jr;
    we.Fragment = n, we.jsx = Yr, we.jsxs = Xr;
  }()), we;
}
process.env.NODE_ENV === "production" ? dt.exports = zs() : dt.exports = Js();
var Ks = dt.exports;
const Cr = cn(null), di = () => {
  const t = ln(Cr);
  if (!t)
    throw new Error("useMatrikkelClient must be used within MatrikkelClientProvider");
  return t;
}, hi = ({ children: t, client: e }) => /* @__PURE__ */ Ks.jsx(Cr.Provider, { value: e, children: t });
export {
  Gs as MatrikkelClient,
  hi as MatrikkelClientProvider,
  li as NaboListeService,
  er as TOMT_DELTASETT,
  ui as TokenService,
  fi as createMatrikkelClient,
  qs as extractAlleAdresser,
  it as getMatrikkelEnhetFromGeometry,
  ci as getMatrikkelEnhetId,
  ii as getMatrikkelEnheterFinn,
  Qt as getTeigGeometries,
  ai as openGrunnbokrapport,
  oi as openMatrikkelrapport,
  Xt as queryMatrikkelenhet,
  di as useMatrikkelClient
};
//# sourceMappingURL=index.mjs.map
